import { Container } from "@chakra-ui/react";
import Header from "./components/Header";
import Content from "./components/Content";

const App = () => {
  return (
    <Container
      // bg={"blackAlpha.900"}
      // color={"whiteAlpha.800"}
      minWidth="full"
      height="100vh"
    >
      <Header />
      <Content />
    </Container>
  );
};

export default App;
